<template>
    <Detail v-if="is_initialized && eventbus.change_current_template.value == 'detail'"
        :core_waybill="core_waybill"
        :statuses="statuses"
        :eventbus="eventbus"
        :scope="scope"

        :is_have_source_core_waybill="is_have_source_core_waybill"
        :is_enable_auto_print_label="is_enable_auto_print_label"
        :is_auto_print="is_auto_print"

        :is_show_change_template_btns="is_show_change_template_btns"
        :is_can_print_label="is_can_print_label"

        :is_can_update="is_can_update"
        :can_update_field_names="can_update_field_names"
        :cant_update_field_names="cant_update_field_names"
        :focus_field_field_name="focus_field_field_name"

        :is_show_partition="template_options.detail.is_show_partition"
        :is_show_statuses="template_options.detail.is_show_statuses"
        :is_show_receipt_file="template_options.detail.is_show_receipt_file"
        :is_show_blood_related="template_options.detail.is_show_blood_related"

        :active_button_color="active_button_options.color"
        :active_button_content="active_button_options.content"
        :active_button_channel="active_button_options.channel"
        :active_button_to_detail_route_name="active_button_options.to_detail_route_name"
        >
    </Detail>

    <Card v-else-if="is_initialized"
        :core_waybill="core_waybill"
        :statuses="statuses"
        :eventbus="eventbus"
        :scope="scope"

        :is_in_scanner_modal="is_in_scanner_modal"
        :is_have_source_core_waybill="is_have_source_core_waybill"
        :is_enable_auto_print_label="is_enable_auto_print_label"
        :is_auto_print="is_auto_print"

        :is_show_change_template_btns="is_show_change_template_btns"
        :is_can_print_label="is_can_print_label"

        :is_can_update="is_can_update"
        :can_update_field_names="can_update_field_names"
        :cant_update_field_names="cant_update_field_names"
        :focus_field_field_name="focus_field_field_name"

        :is_half_style="template_options.card.is_half_style"
        :is_vertical="template_options.card.is_vertical"
        :is_show_note="template_options.card.is_show_note"
        :active_button_color="active_button_options.color"
        :active_button_content="active_button_options.content"
        :active_button_channel="active_button_options.channel"
        :active_button_to_detail_route_name="active_button_options.to_detail_route_name"
        >
    </Card>

    <div
        class="ui segments core_waybill"
        :class="{half: template_options.card.is_half_style && is_half_style}"
        style="text-align:center; height:100px;"
        v-else
    >
        <div
            v-if="core_waybill.number && core_waybill.identity"
            >
            <div
                v-if="is_initialized"
                class="ui button no orange border"
                @click="init()">
                <i class="frown icon"></i>
                <!-- 載入錯誤，點選我重新初始話 -->
                {{ $t('ui.notifications.help.please_clicked_initialize_again') }}
            </div>
            <div
                v-else
                class="ui active inverted dimmer">
                <div class="ui text loader">
                    <h3>{{ $t('ui.general.initializing') }}</h3>
                </div>
            </div>
        </div>
        <div v-else>
            {{ $t('ui.general.no_data') }}
        </div>
    </div>
</template>

<script>
import Detail from '@toolbox/core_waybill/templates/detail.vue'
import Card from '@toolbox/core_waybill/templates/card.vue'

export default {
    name: "ToolCoreWaybillMain",
    components: {
        Detail,
        Card,
    },
    props: {
        /*
         * Main
         */
        core_waybill: {
            default: {},
            type: Object
        },
        statuses: {
            default() { return [] },
            type: Array
        },
        template: {
            default: 'card',
            type: String
        },
        scope: {
            default: 'provider',
            type: String
        },

        /*
         * template 設定
         */
        card: {
            default() { return {} },
            type: Object
        },
        detail: {
            default() { return {} },
            type: Object
        },

        /*
         * 共用
         */
        active_button: {
            default() { return {} },
            type: Object
        },
        is_half_style: {
            default: true,
            type: Boolean
        },
        is_can_print_label: {
            default: false,
            type: Boolean
        },
        is_auto_print: {
            default: false,
            type: Boolean
        },
        is_force_print: {
            default: false,
            type: Boolean
        },
        is_show_change_template_btns: {
            default: true,
            type: Boolean
        },
        is_in_scanner_modal: {
            default: false,
            type: Boolean
        },
        focus_field_field_name: {
            default: "",
            type: String
        },
        label_src: {
            default: "",
            type: String
        },
        label_paper_type: {
            default: "100x100",
            type: String
        },
        /*
            更新全運單欄位 :is_can_update="true"
            反轉，只更新運單部份欄位
                :is_can_update="true"
                :can_update_field_names="['number', '...']"
            更新運單但鎖部份欄位
                :is_can_update="true"
                :cant_update_field_names="['number', '...']"

            can_update_field_names > cant_update_field_names
        */
        is_can_update: {
            default: false,
            type: Boolean
        },
        can_update_field_names: {
            default() { return [] },
            type: Array
        },
        cant_update_field_names: {
            default() { return [] },
            type: Array
        },
    },
    data() {
        return {
            is_initialized: false,
            is_have_source_core_waybill: false,
            is_enable_auto_print_label: true,
            scope_options: {},

            /*
             * template 相關
             */
            template_options: {
                card: {
                    is_half_style: false,
                    is_vertical: false,
                    is_show_note: true,
                },
                detail: {
                    is_show_partition: false,
                    is_show_statuses: false,
                    is_show_receipt_file: false,
                    is_show_blood_related: false,
                },
            },

            /*
             * 按鈕 相關
             */
            active_button_options: {
                color: "",
                content: this.$t('ui.general.update'),
                channel: "",
                to_detail_route_name: ""
            },
            /*
             * evenbus 相關
             */
            eventbus: {}
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.tool_core_waybill_module
        },
        current_label_type() {
            let label_type = (this.core_waybill.material)
                ? this.core_waybill.material.label_type
                : ""

            label_type = (this.core_waybill.partition)
                ? this.core_waybill.partition.label_type
                : label_type

            label_type = (this.core_waybill.label_type)
                ? this.core_waybill.label_type
                : label_type
            return label_type
        },
        current_label_info() {
            return _.findLast(this.current_store.label_infos, (label_info) => {
                return label_info.type == this.current_label_type
            }) || {}
        }
    },
    watch: {
        'core_waybill.number': {
            deep: true,
            handler(value) {
                this.init()
            }
        },
        card: {
            deep: true,
            handler(value) {
                this.init_template_options()
            }
        },
        detail: {
            deep: true,
            handler(value) {
                this.init_template_options()
            }
        },
        template(value) {
            var result = $.extend(true, [], [value])
            this.eventbus.change_current_template.value = result[0]
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        /*
         * ========================================================================
         * Init & basic setting
         * ========================================================================
         */
        async init() {
            this.is_initialized = false
            var add_string = this.is_in_scanner_modal ? '_in_scanner_modal_' : '_'
            var number = this.core_waybill.number
            await this.init_eventbus()
            await this.init_template_options()
            await this.init_active_button_options()

            await this.set_scope_options()
            if (this.core_waybill.identity) {
                add_string += number
                await this.fetch_waybill_label_info()
                await this.fetch_waybill_label()
                await this.set_is_have_source_core_waybill()

                await this.set_eventbus_copy_field(add_string)
                await this.set_eventbus_change_current_template(add_string)
                await this.set_eventbus_file_uploader(add_string)
                await this.set_eventbus_update_core_waybill(add_string)
                await this.set_eventbus_delete_core_waybill(add_string)
                await this.set_eventbus_print_label(add_string)
                await this.set_eventbus_print_label_refetch(add_string)
                await this.check_auto_print()
            }
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        init_template_options() {
            _.forEach(this.template_options.card, (value, option_name) => {
                this.template_options.card[option_name] = (this.card[option_name] != undefined)
                    ? this.card[option_name]
                    : value
            })

            _.forEach(this.template_options.detail, (value, option_name) => {
                this.template_options.detail[option_name] = (this.detail[option_name] != undefined)
                    ? this.detail[option_name]
                    : value
            })

            return Promise.resolve()
        },
        init_active_button_options() {
            _.forEach(this.active_button_options, (value, option_name) => {
                this.active_button_options[option_name] = (this.active_button[option_name] != undefined)
                    ? this.active_button[option_name]
                    : value
            })
            return Promise.resolve()
        },
        set_is_have_source_core_waybill() {
            if (this.core_waybill.source_core_waybill) {
                this.is_have_source_core_waybill = true
            }

            return Promise.resolve()
        },
        set_scope_options() {
            switch (this.scope) {
                case "provider":
                    var routes = this.$store.state.provider.routes
                    this.scope_options = {
                        current_user: this.$store.state.provider.current_staff,
                        token: localStorage.getItem("authentication_token"),
                        urls: {
                            delete_core_waybill: routes.api_v1_provider_core_waybill_delete,
                            update_core_waybill: routes.api_v1_provider_core_waybill_update,
                            core_waybill_label: routes.api_v1_provider_core_waybill_label,
                            core_waybill_label_info: routes.api_v1_provider_papers_label_info,
                            papers_print: routes.api_v1_provider_papers_print,
                            printable: routes.api_v1_provider_core_waybill_printable,
                        },
                    }
                    break
                case "customer":
                    var routes = this.$store.state.customer.routes
                    this.scope_options = {
                        current_user: this.$store.state.customer.node,
                        token: localStorage.getItem("customer_authentication_token"),
                        urls: {
                            update_core_waybill: routes.api_v1_customer_core_waybill_update,
                            core_waybill_label: routes.api_v1_customer_core_waybill_label,
                            core_waybill_label_info: routes.api_v1_customer_papers_label_info,
                            papers_print: routes.api_v1_customer_papers_print,
                            printable: routes.api_v1_customer_core_waybill_printable,
                        },
                    }
                    break
                default:
            }

            return Promise.resolve()
        },
        /*
         * ========================================================================
         * Set eventbus
         * ========================================================================
         */
        init_eventbus() {
            var current_template = $.extend(true, [], [this.template])

            this.eventbus = {
                copy_field: {
                    name: "copy_field",
                },
                change_current_template: {
                    is_processing: false,
                    name: "change_current_template",
                    value: current_template[0],
                    message: "",
                    status: "",
                },
                file_uploader: {
                    is_processing: false,
                    name: "file_uploader",
                    message: "",
                    status: "",
                },
                update_core_waybill: {
                    is_processing: false,
                    name: "update_core_waybill",
                    message: "",
                    status: "",
                },
                delete_core_waybill: {
                    is_down: false,
                    is_processing: false,
                    is_auto_back: false,
                    name: "delete_core_waybill",
                    message: "",
                    status: "",
                },
                print_label: {
                    is_force: false,
                    is_processing: false,
                    refetch_name: "refetch",
                    name: "print_label",
                    src: "",
                    message: "",
                    status: "",
                },
            }

            return Promise.resolve()
        },
        set_eventbus_copy_field(add_string) {
            var current_eventbus = this.eventbus.copy_field
            current_eventbus.name += add_string

            this.$bus.$off(current_eventbus.name)
            this.$bus.$on(current_eventbus.name, (field_name = null) => {
                try {
                    if (!field_name) {
                        throw 'no_field_name'
                    }

                    var target_text = this.core_waybill[field_name]
                    var content = this.$t("models.attributes.core_waybills."+field_name)
                    $('.copy_textarea').remove()
                    var temp_textarea = $("<textarea class='copy_textarea'>")
                    temp_textarea.text(target_text).appendTo('body').select()

                    var successful = document.execCommand('copy')
                    var msg = successful ? 'successful' : 'unsuccessful'
                    this.$noty.information(
                        this.$t('ui.notifications.success.copy__name', {
                            name: content+'(' + target_text + ')'
                        })
                    )
                    temp_textarea.remove()
                } catch (err) {
                    this.$noty.error(
                        this.$t('ui.notifications.error.copy__name', {
                            name: content+'(' + target_text + ')',
                            reason: ': '+ err
                        })
                    )
                }
            })

            return Promise.resolve()
        },
        set_eventbus_change_current_template(add_string) {
            var current_eventbus = this.eventbus.change_current_template
            current_eventbus.name += add_string

            this.$bus.$off(current_eventbus.name)
            this.$bus.$on(current_eventbus.name, (template_name = null) => {
                current_eventbus.is_processing = true
                if (template_name != null) {
                    current_eventbus.value = template_name
                    current_eventbus.status = 'success'
                    current_eventbus.message = ''

                    this.is_enable_auto_print_label = false

                } else {
                    // var message = '切換版形錯誤'
                    var message = this.$t('ui.toolbox.core_waybill.errors.change_template_error')
                    current_eventbus.status = 'failure'
                    current_eventbus.message = message
                    this.$noty.error(message)
                }
                current_eventbus.is_processing = false
            })

            return Promise.resolve()
        },
        set_eventbus_file_uploader(add_string) {
            var current_eventbus = this.eventbus.file_uploader
            current_eventbus.name += add_string

            this.$bus.$off(current_eventbus.name)
            this.$bus.$on(current_eventbus.name, (from, eventname, url) => {
                current_eventbus.is_processing = true
                switch (eventname) {
                    case "uploaded_file":
                        current_eventbus.status = "await"
                        // current_eventbus.message = "上傳中"
                        current_eventbus.message = this.$t('ui.general.uploading')
                        break

                    case "uploading":
                        current_eventbus.status = "await"
                        // current_eventbus.message = "上傳中"
                        current_eventbus.message = this.$t('ui.general.uploading')
                        break

                    case "upload complete":
                        this.update_core_waybill_receipt_file_url(url)
                        current_eventbus.status = "success"
                        // current_eventbus.message = "更新成功"
                        current_eventbus.message = this.$t('ui.notifications.success.update')
                        break

                    case "upload failed":
                        current_eventbus.status = "failure"
                        // current_eventbus.message = "更新失敗"
                        current_eventbus.message = this.$t('ui.notifications.error.update')
                        break
                }
                current_eventbus.is_processing = false
            })
            return Promise.resolve()
        },
        set_eventbus_update_core_waybill(add_string) {
            var current_eventbus = this.eventbus.update_core_waybill
            current_eventbus.name += add_string

            this.$bus.$off(current_eventbus.name)
            this.$bus.$on(current_eventbus.name, async () => {
                current_eventbus.is_processing = true
                await this.update_core_waybill()
                await new Promise(resolve => {
                    current_eventbus.is_processing = false
                })

            })
            return Promise.resolve()
        },
        set_eventbus_delete_core_waybill(add_string) {
            var current_eventbus = this.eventbus.delete_core_waybill
            current_eventbus.is_auto_back = (this.is_in_scanner_modal) ? false : true
            current_eventbus.name += add_string

            this.$bus.$off(current_eventbus.name)
            this.$bus.$on(current_eventbus.name, async () => {
                current_eventbus.is_processing = true
                await this.delete_core_waybill()
                await new Promise(resolve => {
                    current_eventbus.is_processing = false
                })

            })
            return Promise.resolve()
        },
        async set_eventbus_print_label(add_string) {
            var print_event_waybilly_bus_name = "tool_core_waybill_print_label_"+this.core_waybill.number
            var current_eventbus = this.eventbus.print_label
            current_eventbus.name += add_string

            this.$bus.$off(print_event_waybilly_bus_name)
            this.$bus.$on(print_event_waybilly_bus_name, (result) => {
                if (result.status == "success") {
                    current_eventbus.status = "success"
                    current_eventbus.message = ""
                    this.print_core_waybill_label()
                } else {
                    this.$noty.error(result.error)
                    current_eventbus.status = "failure"
                    current_eventbus.message = result.error
                }
            })

            this.$bus.$off(current_eventbus.name)
            this.$bus.$on(current_eventbus.name, async () => {
                try {
                    current_eventbus.is_processing = true
                    if (!this.core_waybill.number) {
                        // throw "無號碼"
                        throw this.$t('ui.toolbox.core_waybill.errors.no_number')
                    }

                    if (!current_eventbus.src) {
                        // throw "載入圖片無效"
                        throw this.$t('ui.toolbox.core_waybill.errors.invalid_loading_image')
                    }

                    $('div#print *').remove()
                    if (this.is_in_scanner_modal) {
                        await this.$bus.$emit(
                            "is_print_waybill",
                            this.core_waybill.number,
                            print_event_waybilly_bus_name
                        )
                    } else {
                        this.print_core_waybill_label()
                    }

                } catch (message) {
                    current_eventbus.status = "failure"
                    current_eventbus.message = message
                }

                current_eventbus.is_processing = false
            })
            return Promise.resolve()
        },
        async set_eventbus_print_label_refetch(add_string) {
            var current_eventbus = this.eventbus.print_label

            current_eventbus.refetch_name += add_string
            this.$bus.$off(current_eventbus.refetch_name)
            this.$bus.$on(current_eventbus.refetch_name, () => {
                this.fetch_waybill_label()
            })
            return Promise.resolve()
        },
        /*
         * ========================================================================
         * Actions
         * ========================================================================
         */
        fetch_waybill_label() {
            try {
                this.$set(this.eventbus.print_label, 'src', '')
                this.$set(this.eventbus.print_label, 'is_processing', true)

                if (this.label_src != "") {
                    this.$set(this.eventbus.print_label, 'src', `${this.label_src}&lastmod=${Math.random() * 10000}`)

                } else {
                    let label_type = (this.core_waybill.material)
                        ? this.core_waybill.material.label_type
                        : ""

                    label_type = (this.core_waybill.partition)
                        ? this.core_waybill.partition.label_type
                        : ""

                    label_type = (this.core_waybill.label_type)
                        ? this.core_waybill.label_type
                        : label_type


                    if (label_type == "" || label_type == null) {
                        // throw "此運單無綁定標籤種類，無法產標"
                        throw this.$t('ui.toolbox.core_waybill.errors.waybill_no_label_class_cant_print')
                    }
                    if (!this.is_can_print_label) {
                        // throw "參數 is_can_print_label 無啟用"
                        throw this.$t('ui.toolbox.core_waybill.errors.props_is_can_print_label_unable')
                    }

                    // 20200602 change to paper api
                    // 範例
                    // local.mynet.com.tw:3000/v1/provider/papers/print.svg?paper_size=30x100&template=1x1&contents=[{"core_waybill_number":"X515431","printing_type":"Label::Default","label_height":"30","label_width":"100","is_hide_tw568_barcode":"true"}]&authorization=eyJhbGciOiJIUzI1NiJ9.eyJwcm92aWRlcl9ub2RlX2lkZW50aXR5IjoiN2NiMDYyNWMxNi0yODAzNi0zOTc2ODI5MiIsImN1c3RvbWVyX2lkZW50aXR5IjpudWxsLCJzdGFmZl9pZGVudGl0eSI6IjY2NDRkODhjZTNjZjkxM2QtMjgwMzYtMTc0MjI0ODM2MCIsInN0YXRpb25faWRlbnRpdHkiOm51bGwsImNvbnRyYWN0X2lkZW50aXR5IjpudWxsLCJyb2xlIjoic3RhZmYifQ.rE9c2s62qONq0jkt37tdH_HuMD7QK8jZoZxyXAJ6DJ0

                    let current_label_paper_type = ""
                    if (this.current_label_info.height && this.current_label_info.width) {
                        current_label_paper_type = `${this.current_label_info.height}x${this.current_label_info.width}`
                    } else {
                        current_label_paper_type = this.label_paper_type
                    }
                    let parameters = `.svg?paper_size=${current_label_paper_type}` +
                        `&template=1x1` +
                        `&authorization=${this.scope_options.token}`

                    let contents = [{
                        core_waybill_number: this.core_waybill.number,
                        core_waybill_identity: this.core_waybill.identity,
                        printing_type: label_type,
                        data: this.get_core_waybill_label_data_params()
                    }]

                    if (this.scope == 'provider') {
                        contents[0].staff_identity = this.scope_options.current_user.identity
                    }

                    let url = this.scope_options.urls.papers_print
                        + parameters
                        + `&contents=${JSON.stringify(contents)}`
                        + `&lastmod=${Math.random() * 10000}`

                    this.$set(this.eventbus.print_label, 'src', url)
                    // this.$set(this.eventbus.print_label, "src", new RestUrl(this.scope_options.urls.core_waybill_label).parse(
                    //     {core_waybill_identity: this.core_waybill.identity},
                    //     ".svg"+parameters
                    // ))
                }

                this.$set(this.eventbus.print_label, 'status', 'success')

            } catch (message) {
                this.$set(this.eventbus.print_label, 'status', 'failure')
                this.$set(this.eventbus.print_label, 'message', message)

            } finally {
                this.$set(this.eventbus.print_label, 'is_processing', false)
            }

            return Promise.resolve()
        },
        fetch_waybill_label_info() {
            if (this.current_label_info.type || this.label_src != "") {
                return Promise.resolve()

            } else {
                let url = this.scope_options.urls.core_waybill_label_info
                if (this.current_label_type) {
                    return axios.get(`${url}?label_type=${this.current_label_type}`, {
                        headers: { Authorization: this.scope_options.token }
                    })
                    .then((response) => {
                        console.log('fetch_waybill_label_info response.data', response.data);
                        if (response.data.status == "success") {
                            this.current_store.label_infos.push({
                                type: this.current_label_type,
                                height: response.data.label_info.height,
                                width: response.data.label_info.width
                            })
                        } else {
                            console.log('fetch_waybill_label_info failure', response.data);
                        }
                    })
                    .catch((error) => {
                        console.log('fetch_waybill_label_info error', error);
                        if (!error.response) {
                            // Network Error
                            this.$noty.error(
                                this.$t('ui.general.network_abnormality')+": "+
                                this.$t('ui.general.server_offline')
                            )
                        } else {
                            this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                        }
                    })
                }
            }
        },
        check_auto_print() {
            if (
                this.is_auto_print == true &&
                this.is_enable_auto_print_label &&
                this.eventbus.print_label.src
            ) {
                this.print_core_waybill_label()
            }
            return Promise.resolve()
        },
        update_core_waybill() {
            var params = this.core_waybill
            var url = new RestUrl(this.scope_options.urls.update_core_waybill).parse(
                {
                    "core_waybill_identity": this.core_waybill.identity,
                }
            )

            return axios.post(url, params, {
                headers: { Authorization: (this.scope_options.token || localStorage.getItem("customer_authentication_token")) }
            })
            .then((response) => {
                if (response.data.status == "success") {
                    // this.$noty.success("運單更新成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.update__name', {
                            name: this.$t('models.core_waybills')
                        })
                    )
                    this.fetch_waybill_label()
                } else {
                    console.log(response.data)
                    // this.$noty.error("運單更新失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.core_waybills'),
                        })
                    )
                }
            })
            .catch((error) => {
                console.log(error)
                if (!error.response) {
                    // Network Error
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    )
                } else {
                    this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                }
            })
        },
        delete_core_waybill() {
            var params = this.core_waybill
            var current_eventbus = this.eventbus.delete_core_waybill
            var url = new RestUrl(this.scope_options.urls.delete_core_waybill).parse(
                {
                    "core_waybill_identity": this.core_waybill.identity,
                }
            )

            return axios.get(url, {
                headers: { Authorization: localStorage.getItem("authentication_token") }
            })
            .then((response) => {
                console.log(response.data)
                current_eventbus.status = response.data.status

                if (response.data.status == "success") {
                    current_eventbus.is_down = true

                    var material_staring = (this.core_waybill.material) ? '[' + this.core_waybill.material.name + ']' : ''
                    var staring = this.core_waybill.number
                    current_eventbus.message = this.$t('ui.notifications.success.delete__name', {
                        name: " " + staring + material_staring + " "
                    })
                    this.$noty.success(current_eventbus.message, 5000)
                    if (current_eventbus.is_auto_back) {
                        this.$router.go(-1)
                    }
                } else {
                    current_eventbus.message = this.$t('ui.notifications.error.delete__name', {
                        name: this.$t('models.core_waybills'),
                    })
                    this.$noty.error(current_eventbus.message)
                }
            })
            .catch((error) => {
                console.log(error)
                if (!error.response) {
                    // Network Error
                    current_eventbus.message = this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                } else {
                    current_eventbus.message = this.$t('ui.general.network_abnormality')+': ' +
                        error.response.status + error.response.data
                }
                this.$noty.error(current_eventbus.message)
            })
        },
        update_core_waybill_receipt_file_url(url) {
            this.core_waybill.receipt_file_url = url
            // Prepare parameters
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybill_update).parse(
                {
                    "core_waybill_identity": this.core_waybill.identity,
                }
            )

            axios.post(
                url,
                this.core_waybill,
                {
                    headers: { Authorization: localStorage.getItem("authentication_token")
                }
            })
            .then((response) => {
                if (response.data.status == "success") {
                    // this.$noty.success("運單更新成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.update__name', {
                            name: this.$t('models.core_waybills')
                        })
                    )
                } else {
                    console.log(response.data)
                    // this.$noty.error("運單更新失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.core_waybills'),
                        })
                    )
                }
            })
            .catch((error) => {
                console.log(error)
                if (!error.response) {
                    // Network Error
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    )
                } else {
                    this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                }
            })
        },

        /*
         * ========================================================================
         * Print
         * ========================================================================
         */
        get_core_waybill_label_data_params() {
            let provider_node = this.$store.state.provider.node
            try {
                if (provider_node && provider_node.identity == '1d881a85155831dd-28036-39768292') {
                    console.log('//// Into label other params logic ////');
                    // Get count by localStorage
                    let print_label_counts = JSON.parse(
                        localStorage.getItem('print_label_counts')
                    ) || []
                    console.log('print_label_counts', print_label_counts);
                    // Get current_count or init current_count
                    let current_print_label_count = _.findLast(print_label_counts, (print_label) => {
                        return print_label.identity == this.core_waybill.identity
                    }) || {
                        identity: this.core_waybill.identity,
                        count: Number(this.core_waybill.note_2) || Number(this.core_waybill.count) || 1,
                        serial: 0,
                    }

                    // if 第幾件+1 <= 種件數
                    if (current_print_label_count.serial +1 <= current_print_label_count.count) {
                        current_print_label_count.serial += 1
                    }
                    console.log('//// End label other params logic ////');

                    return {
                        serial: current_print_label_count.serial,
                        count: current_print_label_count.count
                    }
                }
            } catch (e) {
                console.log('ToolCoreWwaybill async get_core_waybill_label_data_params error');
                console.log(e);
            }
            return {}
        },
        async print_core_waybill_label() {
            let can_print = await this.printable()
            let label_src = this.eventbus.print_label.src
            if (can_print) {
                await new Promise(resolve => {
                    let current_label_paper_type = ""
                    if (this.current_label_info.height && this.current_label_info.width) {
                        current_label_paper_type = `${this.current_label_info.width}x${this.current_label_info.height}`
                    } else {
                        current_label_paper_type = this.label_paper_type
                    }
                    this.$bus.$emit("add_image_print_job", {
                        note: this.core_waybill.number,
                        images: [{
                            name: this.eventbus.print_label.name,
                            src: label_src
                        }],
                        paper_type: current_label_paper_type || "100x100",
                        numbers_of_one_page: 1,
                    })
                    resolve()
                })
                await new Promise(resolve => {
                    try {
                        let label_url_params = this.get_core_waybill_label_data_params()
                        if (label_url_params) {
                            // 複寫 localStorage
                            let print_label_counts = JSON.parse(
                                localStorage.getItem('print_label_counts')
                            ) || []
                            let index = _.findIndex(print_label_counts, {
                                identity: this.core_waybill.identity
                            })
                            let current_print_label_count = Object.assign(label_url_params, {
                                identity: this.core_waybill.identity
                            })
                            console.log('index', index)
                            if (index == -1) {
                                print_label_counts.push(current_print_label_count)
                            } else {
                                print_label_counts.splice(index, 1, current_print_label_count)
                            }
                            localStorage.setItem('print_label_counts', JSON.stringify(print_label_counts))
                        }
                    } catch (e) {
                        console.log('ToolCoreWwaybill async print_core_waybill_label error');
                        console.log(e);
                    }
                    resolve()
                })
                await new Promise(resolve => {
                    this.eventbus.print_label.src = ""
                    this.$bus.$emit(this.eventbus.print_label.refetch_name)
                    this.$forceUpdate()
                    resolve()
                })
            }
        },
        printable() {
            if (this.core_waybill.identity && this.core_waybill.identity.includes("is_fake_identity")) {
                return true
            }

            let url = new RestUrl(this.scope_options.urls.printable).parse({
                "core_waybill_identity": this.core_waybill.identity
            })
            if (this.eventbus.print_label.is_force || this.is_force_print) {
                url += '?is_force=true'
            }

            return axios.get(url, {
                headers: { Authorization: this.scope_options.token }
            })
            .then(response => {
                let result = false
                if (response.data.status == "success") {
                    result = true
                }
                this.$set(this.eventbus.print_label, 'is_force', !result)
                return result
            })
            .catch(error => {
                if (!error.response) {
                    // Network Error
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    )
                } else {
                    this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                }
                return false
            })
        },
        handle_fetch_waybill_label_errors(content = "") {
            switch (content) {
                case 'Params print_type not found':
                    // return '無指定標籤種類'
                    return this.$t('ui.toolbox.core_waybill.errors.no_label_type')
                    break
                case 'Params print_type error':
                    // return '標籤種類錯誤'
                    return this.$t('ui.toolbox.core_waybill.errors.label_type_error')
                    break
                case 'Params page_size error':
                    // return '紙張種類錯誤'
                    return this.$t('ui.toolbox.core_waybill.errors.label_paper_type_error')
                    break
                default:
                    return content
                }
        },
    },
}
</script>
<style lang="scss" scoped>
    @import ".assets/stylesheets/common_card.scss";
</style>
